import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=ccea8ad0&scoped=true"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=ccea8ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccea8ad0",
  null
  
)

export default component.exports